import { Day, EventTimetableState, Prisma } from "@prisma/client";
import { DefaultArgs } from "@prisma/client/runtime/library";

export const states = EventTimetableState
  ? Object.values(EventTimetableState)
  : [];

export const getEventTimetableState = (state: EventTimetableState) => {
  switch (state) {
    case EventTimetableState.continuouslyOpened:
      return "Ouvert en continu";
    case EventTimetableState.opened:
      return "Ouvert";
    case EventTimetableState.closed:
      return "Fermé";
  }
};

export interface EventTimetableType {
  id: string;

  day: Day;
  state: EventTimetableState;
  openingTime: string | null;
  closingTime: string | null;
  breakStartTime: string | null;
  breakEndTime: string | null;

  createdAt: Date;
  updatedAt: Date;
}

export interface EventDateRange {
  id: string;
  eventDateId: string;

  fromDate: string;
  toDate: string;

  timetables: EventTimetableType[];
}

export interface EventExceptionalDate {
  id: string;
  eventDateId: string;

  date: string;
}

export const eventDateValues = Prisma.validator<
  Prisma.Event$datesArgs<DefaultArgs>
>()({
  include: {
    schedules: {
      orderBy: {
        fromDate: "asc",
      },
      include: {
        timetables: {
          orderBy: {
            day: "asc",
          },
        },
      },
    },
    exceptionalClosingDates: {
      orderBy: {
        date: "asc",
      },
    },
  },
});

export interface EventDate {
  id: string;

  schedules: EventDateRange[];

  exceptionalClosingDates: EventExceptionalDate[];

  isContinuous: boolean;
}
